/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Scope_Conversions_CreateInputs */

const en_mcp_connect_scope_conversions_create = /** @type {(inputs: Mcp_Connect_Scope_Conversions_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add text and documents to your library using your existing upload allowance`)
};

const es_mcp_connect_scope_conversions_create = /** @type {(inputs: Mcp_Connect_Scope_Conversions_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir textos y documentos a tu biblioteca con tu límite de subidas actual`)
};

/**
* | output |
* | --- |
* | "Add text and documents to your library using your existing upload allowance" |
*
* @param {Mcp_Connect_Scope_Conversions_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_scope_conversions_create = /** @type {((inputs?: Mcp_Connect_Scope_Conversions_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Scope_Conversions_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_scope_conversions_create(inputs)
	return en_mcp_connect_scope_conversions_create(inputs)
});